import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  NgxUiLoaderModule } from 'ngx-ui-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapComponent } from './google-map.component';
import { GoogleMapRoutingModule } from './google-map-routing.module';
@NgModule({
  declarations: [
    GoogleMapComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
   NgxUiLoaderModule,
   GoogleMapRoutingModule
  ],
  exports:[GoogleMapComponent],
})
export class GoogleMapModule { }
